import { useMemo } from 'react';

interface Tenant {
  tId: number;
  tName: string;
  tLegalName: string;
}

export const turniejeOrg: Tenant = { tId: 1, tName: 'Turnieje.org', tLegalName: 'Turnieje.org Sp. z o.o.' };
const podhaleCup: Tenant = { tId: 2, tName: 'Podhale CUP', tLegalName: "SPORT EVENT'S" }; // KONRAD WILK NIP: 5741979066" };

export const tenants: Tenant[] = [turniejeOrg, podhaleCup];

export const getTenantName = (id: number) => {
  return tenants.find((t) => t.tId === id)?.tName ?? '-';
};

const useTenant = () => {
  const hostname = window.location.hostname + (window.location.port ? `:${window.location.port}` : '');

  const tenant = useMemo(() => {
    const domainToTenant: Record<string, Tenant> = {
      'app.turnieje.org': turniejeOrg, // Default tenant
      'podhalecup.turnieje.org': podhaleCup,

      localhost: turniejeOrg, // Default tenant for localhost
      'localhost:3000': turniejeOrg,

      // localhost: podhaleCup, // Default tenant for localhost
      // 'localhost:3000': podhaleCup,
    };
    return domainToTenant[hostname] || turniejeOrg;
  }, [hostname]);

  return tenant;
};

export default useTenant;
